import { NavLink } from 'react-router-dom';

import Sheet from '../../../common/components/sheet/sheet';
import ChevronRightIcon from '../../../common/icons/chevron-right';

import '../styles/more-sheet.css';

export default function MoreSheet({ isOpen, items, badges, onClose }) {
    return (
        <Sheet isOpen={isOpen} title="Más secciones" onClose={onClose}>
            <ul className="more-sheet">
                {items.map(({ key, label, path, Icon }) => (
                    <li key={key}>
                        <NavLink
                            to={path}
                            onClick={onClose}
                            className={({ isActive }) => `more-sheet__link${isActive ? ' more-sheet__link--active' : ''}`}
                        >
                            <span className="more-sheet__icon"><Icon size={22} /></span>
                            <span className="more-sheet__label">{label}</span>
                            {badges[key] > 0 && (
                                <span className="more-sheet__badge">
                                    {badges[key]}
                                    <span className="visually-hidden"> pendientes</span>
                                </span>
                            )}
                            <ChevronRightIcon size={18} className="more-sheet__chevron" />
                        </NavLink>
                    </li>
                ))}
            </ul>
        </Sheet>
    );
}
